// src/App.js
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import TonKhoPage from './pages/TonKhoPage';
import HangNhapPage from './pages/HangNhapPage';
import HangXuatPage from './pages/HangXuatPage';
import NhanVienPage from './pages/NhanVienPage';
import TheoDoiDonHangPage from './pages/TheoDoiDonHangPage';
import DashboardPage from './pages/DashboardPage';
import HomePage from './pages/HomePage';
import CongNoNhapPage from './pages/CongNoNhapPage';
import CongNoXuatPage from './pages/CongNoXuatPage';
import TheoDoiVoCanPage from './pages/TheoDoiVoCanPage';
import EditPage from './pages/EditPage'; // Import trang mới
import { AppProvider } from './context/AppContext';
import { AppThemeProvider, useThemeContext } from './context/ThemeContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ThemeProvider as MuiThemeProvider, CssBaseline } from '@mui/material';

const BaoCao = () => <div>Nội dung trang Báo Cáo</div>;

function ThemedApp() {
    const { theme } = useThemeContext();
    return (
        <MuiThemeProvider theme={theme}>
            <CssBaseline />
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                        <Route index element={<HomePage />} /> 
                        <Route path="dashboard" element={<DashboardPage />} /> 
                        <Route path="hang-nhap" element={<HangNhapPage />} />
                        <Route path="hang-xuat" element={<HangXuatPage />} />
                        <Route path="ton-kho" element={<TonKhoPage />} />
                        <Route path="bao-cao" element={<BaoCao />} />
                        <Route path="nhan-vien" element={<NhanVienPage />} />
                        <Route path="theo-doi-don-hang" element={<TheoDoiDonHangPage />} />
                        <Route path="cong-no-nhap" element={<CongNoNhapPage />} />
                        <Route path="cong-no-xuat" element={<CongNoXuatPage />} />
                        <Route path="theo-doi-vo-can" element={<TheoDoiVoCanPage />} />
                        <Route path="chinh-sua" element={<EditPage />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </MuiThemeProvider>
    );
}

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <AppProvider>
        <AppThemeProvider>
            <ThemedApp />
        </AppThemeProvider>
      </AppProvider>
    </LocalizationProvider>
  );
}

export default App;
